export function getNeededStartsFromGitHubPlan(plan) {
    if (!plan.rules) {
        return false;
    }
    try {
        return JSON.parse(plan.rules).githubStars;
    } catch (e) {
        console.error(`Invalid plan rules: ${JSON.stringify(plan)}`);
        return false;
    }
}